import React, { useEffect, useState } from 'react'
import axios from 'axios';
import * as CONSTANTS from "../../CONSTANTS";
import DashboardOnvite1 from "./onsiteDashboard/DashboardOnvite1";
import DashboardOnvite2 from "./onsiteDashboard/DashboardOnvite2";
import DashboardOnvite3 from "./onsiteDashboard/DashboardOnvite3";
import DashboardRSVP from "./onsiteDashboard/DashboardRSVP";
import DashboardMessage from "./onsiteDashboard/DashboardMessage";
import DashboardCatalogue from './onsiteDashboard/DashboardCatalogue';

function ProfileWidgetOnsite({user}) {

    const [updateAction, setUpdateAction]                            = useState(0);

    const [page, setPage]                                            = useState(1);
    const [processing, setProcessing]                                = useState(false);
    const [eventList, setEventList]                                  = useState([]);
    const [selectedEvent, setSelectedEvent]                          = useState(null);

    const pills = [
      "Onvite Details 1",
      "Onvite Details 2",
      "Location",
      "RSVP",
      "Messages",
      "Catalogue",
      "Other"
    ];

    // Components for each tab
    const pillContent = {
      "Onvite Details 1": <DashboardOnvite1 user={user} selectedEvent={selectedEvent} setUpdateAction={setUpdateAction} />,
      "Onvite Details 2": <DashboardOnvite2 user={user} selectedEvent={selectedEvent} setUpdateAction={setUpdateAction}/>,
      "Location": <DashboardOnvite3 user={user} selectedEvent={selectedEvent} setUpdateAction={setUpdateAction} />,
      "RSVP": <DashboardRSVP user={user} selectedEvent={selectedEvent} />,
      "Messages": <DashboardMessage user={user} selectedEvent={selectedEvent} />,
      "Catalogue": <DashboardCatalogue user={user} selectedEvent={selectedEvent} setUpdateAction={setUpdateAction} />,
      "Other": <div>Other content</div>
    };

    const [selectedPill, setSelectedPill]     = useState(pills[0]);
    
    useEffect(() => {
      collectYourCurrentWeddings();
    },[updateAction])

    const collectYourCurrentWeddings = async () => {
      try{

        setProcessing(true);
        
        const obItem = {
          "userid" : user._id,
          "page": page
        }

        const response = await axios.put(CONSTANTS.API_URL +"annivites/list/v1/onvite/user/", obItem, {
            headers: {
              token: 'Bearer ' + user.accessToken,
            },
          });
        //console.log(")))))) (((((((");
        //console.log(response.data.length);
        setEventList(response.data);
        if(updateAction < 1 || response.data.length === 1){
          setSelectedEvent(response.data[0]);
        }
        setProcessing(false);
    }catch(errorData){
      setProcessing(false);
      console.log(errorData);
    }
  }
  
  return (
    <div className="card shadow-sm h-100">
        <div className="card-body">
            
            <div className="row">
                {/* Sidebar */}
                <div className="col-md-3 border-end" style={{ height: "80vh", overflowY: "auto" }}>
                    {
                      eventList.length > 0 && (
                        <div className="list-group">
                        {
                          eventList.map((event, index) => (
                            <button
                              key={index}
                              className={`group-view-item ${
                                selectedEvent === event ? "active" : ""
                              }`}
                              onClick={() => setSelectedEvent(event)}
                            >
                              {event.spouseA} & {event.spouseB} <br />
                              <small className="text-muted">{event.weddingDate}</small>
                            </button>
                          ))
                        }
                        </div>
                      )                         
                    }                  
                </div>

                {/* Main Content */}
                <div className="col-md-9">
                  {
                    selectedEvent ? (
                      <div className="dashboard-blade">
                         <div className="dash-head scrollable-pills-container nav nav-pills mb-3">
                          {pills.map((pill, index) => (
                            <button
                              key={index}
                              className={`nav-link pill-play ${selectedPill === pill ? "active" : ""}`}
                              onClick={() => setSelectedPill(pill)}
                            >
                              {pill}
                            </button>
                          ))}
                        </div>

                        <div className="dash-body creamyback selected-pill-item border p-3">
                          {pillContent[selectedPill]}
                        </div>
                      </div>
                    ) : (
                      <p>No Onvites have been created.</p>
                    )
                  }
                </div>
              </div>
        </div>
    </div>
  )
}

export default ProfileWidgetOnsite